class EstablishmentRequestDTO {
	constructor({
        company,
        company_fantasy,
        website,
        product,
        age,
        establishment_type,
        product_category,
        product_description,
        product_shipping,
        sameAddress,
        hasGroup,
	}) {
        this.company = company;
		this.company_fantasy = company_fantasy;
		this.website = website;
		this.product = product;
		this.age = age;
		this.establishment_type = establishment_type;
		this.product_category = product_category;
		this.product_description = product_description;
		this.product_shipping = product_shipping;
		this.sameAddress = sameAddress;
        this.hasGroup = hasGroup;
	}
}

export default EstablishmentRequestDTO;
